import { Typography, Box } from "@mui/material";
import React, { useMemo, useState } from "react";
import PastOrders from "../../components/PastOrders";
import { container } from "../ProfilePage/ProfilePage.styles";
import CurrentOrders from "../../components/CurrentOrders/CurrentOrders.view";
import { useAppSelector } from "../../redux/hook";
import { getColors, isObjectNotNull } from "../../utils";
import OrdersFilter from "./Components/OrdersFilter";
import { Button } from "@dishopsaas/design-system";
import { TERTIARY } from "../../constants";
import { FILTER_STATUS_OPTIONS } from '../../constants/ordersFilter'
import {
  filterOrders,
  Filters,
  getFilteredCurrentOrders,
  getFilteredPastOrders,
} from "./OrdersPage.service";

export const OrdersPage = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const [filters, setFilters] = useState<Filters>({
    status: FILTER_STATUS_OPTIONS.map((opt) => opt.value),
    date: "",
  });

  const { orders, pastOrders, canceledOrders } = useAppSelector(
    (state) => state.orderReducer
  );


  const filteredCurrentOrders = useMemo(
    () => getFilteredCurrentOrders(orders, filters, filterOrders),
    [orders, filters]
  );

  const filteredPastOrders = useMemo(
    () =>
      getFilteredPastOrders(
        pastOrders,
        canceledOrders,
        filters,
        filterOrders
      ),
    [pastOrders, canceledOrders, filters]
  );


  const hasCurrent = filteredCurrentOrders.length > 0;
  const hasPast = filteredPastOrders.length > 0;

  const hasFilters =
    filters.status.length > 0 || filters.date;

  const isEmpty = !hasCurrent && !hasPast;

  const handleOpenFilter = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseFilter = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ ...container, color: getColors().text }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        alignSelf='stretch'
      >
        <Typography variant="h4">Mes commandes</Typography>

        <Button
          onClick={handleOpenFilter}
          leftIcon="ListFilter"
          label="Filtres"
          colorType={TERTIARY}
        />
      </Box>

      {hasCurrent && (
        <>
          <Typography variant="h5">
            En cours
          </Typography>
          <CurrentOrders orders={filteredCurrentOrders} />
        </>
      )}

      {hasPast && (
        <>
          <Typography variant="h5">
            Historique
          </Typography>
          <PastOrders orders={filteredPastOrders} />
        </>
      )}

      {isEmpty && (

        <Typography variant="h6">
          {hasFilters && isObjectNotNull(orders)
            ? "Aucune commande ne correspond à vos filtres"
            : "Vous n’avez encore jamais passé commande"}
        </Typography>


      )}

      <OrdersFilter
        anchorEl={anchorEl}
        onClose={handleCloseFilter}
        filters={filters}
        setFilters={setFilters}
      />
    </Box>
  );
};